import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheSpiritOfTheMill from "./sections/TheSpiritOfTheMill";
import FromOurKitchen from "./sections/FromOurKitchen";
import TheTrattoriaAtmosphere from "./sections/TheTrattoriaAtmosphere";
import TheEcoShineProcess from "./sections/TheEcoShineProcess";
import RealTimeMarketPulse from "./sections/RealTimeMarketPulse";
import VoiceOfTheAgent from "./sections/VoiceOfTheAgent";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheSpiritOfTheMill />
      <FromOurKitchen />
      <TheTrattoriaAtmosphere />
      <TheEcoShineProcess />
      <RealTimeMarketPulse />
      <VoiceOfTheAgent />
      <Footer />
    </div>;
}